import React from "react";
import { Outlet } from "react-router-dom";

export function lazyRouteElement(importFn) {
  const LazyComponent = React.lazy(importFn);
  return <LazyComponent />;
}

const websitePublicRoutes = [
  {
    path: "",
    element: lazyRouteElement(() => import("webshop/pages/landing/LandingPage")),
  },
  {
    path: "merken",
    element: lazyRouteElement(() =>
      import("webshop/pages/brands/BrandsPage")
    ),
  },
  {
    path: "certificate",
    element: lazyRouteElement(() =>
      import("intranet/pages/public/download_cert")
    ),
  },
  {
    path: "promofolders",
    element: lazyRouteElement(() =>
      import("webshop/pages/promofolders/PromoFoldersGrid")
    ),
  },
  {
    path: "promofolders/:folderName",
    element: lazyRouteElement(() =>
      import("webshop/pages/promofolders/PromoFolder")
    ),
  },
  // TODO: There are better ways to do this, but for now this is a quick fix
  {
    path: "folders",
    element: lazyRouteElement(() =>
      import("webshop/pages/promofolders/PromoFoldersGrid")
    ),
  },
  {
    path: "folders/:folderName",
    element: lazyRouteElement(() =>
      import("webshop/pages/promofolders/PromoFolder")
    ),
  },
  {
    path: "legal",
    children: [
      {
        path: "additional-terms",
        element: lazyRouteElement(() =>
          import("webshop/pages/other/additional-terms/AdditionalTermsPage")
        ),
      },
    ],
  },
  {
    path: "docs",
    children: [
      {
        path: "",
        element: lazyRouteElement(() =>
          import("webshop/pages/docs/ProductDocuments")
        ),
      },
    ],
  },
  {
    path: "other",
    children: [
      {
        path: "about",
        element: lazyRouteElement(() =>
          import("webshop/pages/other/about/AboutPage")
        ),
      },
      {
        path: "en1090",
        element: lazyRouteElement(() =>
          import("webshop/pages/other/en1090/EN1090Page")
        ),
      },
      {
        path: "zsb",
        element: lazyRouteElement(() =>
          import("webshop/pages/other/zsb/SpecialOrderPage")
        ),
      },
      {
        path: "contact",
        element: lazyRouteElement(() =>
          import("webshop/pages/other/contact/ContactPage")
        ),
      },
      {
        path: "returns",
        element: lazyRouteElement(() =>
          import("webshop/pages/other/returns/ReturnsPage")
        ),
      },
    ],
  },
  {
    path: "page",
    children: [
      {
        path: ":pageName",
        element: lazyRouteElement(() =>
          import("webshop/pages/page/AnyHtmlPage")
        ),
      },
    ],
  },
  {
    path: "shop",
    children: [
      {
        path: "",
        element: lazyRouteElement(() =>
          import("shared/welda/features/shop/products/pages/ProductsPage")
        ),
      },
      {
        path: "c/*",
        element: lazyRouteElement(() =>
          import("shared/welda/features/shop/products/pages/ProductsPage")
        ),
      },

      {
        path: "product/:artikelnr",
        element: lazyRouteElement(() =>
          import(
            "shared/welda/features/shop/products/product-details/ProductDetails"
          )
        ),
      },
      {
        path: "pg",
        children: [
          {
            path: ":productGroupName",
            element: lazyRouteElement(() =>
              import(
                "shared/welda/features/shop/products/product-group/ProductGroupPage"
              )
            ),
          },
        ],
      },

      {
        path: "cart",
        element: lazyRouteElement(() =>
          import("shared/welda/features/shop/cart/Cart")
        ),
      },

      {
        path: "checkout",
        element: lazyRouteElement(() =>
          import("webshop/features/shop/pages/checkout/ClientCheckoutPage")
        ),
      },
      {
        path: "request-quote",
        element: lazyRouteElement(() =>
          import(
            "webshop/features/shop/pages/request-quote/ClientQuoteRequestPage"
          )
        ),
      },

      {
        path: "order/:orderId",
        element: lazyRouteElement(() =>
          import("webshop/features/shop/pages/order/ClientOrderPage")
        ),
      },
    ],
  },
  {
    path: "services",
    element: lazyRouteElement(() =>
      import("webshop/pages/services/ServicesPage")
    ),
    children: [
      {
        path: "advice",
        element: lazyRouteElement(() =>
          import("webshop/pages/services/tabs/Advice")
        ),
      },
      {
        path: "demo",
        element: lazyRouteElement(() =>
          import("webshop/pages/services/tabs/Demo")
        ),
      },
      {
        path: "transport",
        element: lazyRouteElement(() =>
          import("webshop/pages/services/tabs/Transport")
        ),
      },
      {
        path: "maintenance",
        element: lazyRouteElement(() =>
          import("webshop/pages/services/tabs/Maintenance")
        ),
      },
      {
        path: "certification",
        element: <Outlet />,
        children: [
          {
            index: true,
            element: lazyRouteElement(() =>
              import("webshop/pages/services/tabs/Certification")
            ),
          },
          {
            path: ":topic",
            element: lazyRouteElement(() =>
              import(
                "webshop/pages/services/certification/CertificationTopicPage"
              )
            ),
          },
        ],
      },
      {
        path: "repair",
        element: lazyRouteElement(() =>
          import("webshop/pages/services/tabs/Repair")
        ),
      },
      {
        path: "takeover",
        element: lazyRouteElement(() =>
          import("webshop/pages/services/tabs/Takeover")
        ),
      },
      {
        path: "training",
        element: lazyRouteElement(() =>
          import("webshop/pages/services/tabs/Training")
        ),
      },
      {
        path: "rental",
        element: lazyRouteElement(() =>
          import("webshop/pages/services/tabs/Rental")
        ),
      },
    ],
  },

  {
    path: "auth",
    children: [
      {
        path: "register",
        element: lazyRouteElement(() =>
          import("webshop/features/auth/pages/ClientRegisterPage")
        ),
      },
      {
        path: "login",
        element: lazyRouteElement(() =>
          import("webshop/features/auth/pages/ClientLoginPage")
        ),
      },
      {
        path: "logout",
        element: lazyRouteElement(() =>
          import("webshop/features/auth/components/logout/ClientLogout")
        ),
      },
      {
        path: "verify-email",
        element: lazyRouteElement(() =>
          import(
            "webshop/features/auth/pages/ClientEmailVerificationProcessPage"
          )
        ),
      },
      {
        path: "verify-organization-member",
        element: lazyRouteElement(() =>
          import(
            "webshop/features/auth/pages/ClientOrganizationMemberVerificationPage"
          )
        ),
      },
      {
        path: "reset-password",
        element: lazyRouteElement(() =>
          import("webshop/features/auth/pages/ClientPasswordResetProcessPage")
        ),
      },
      {
        path: "request-reset-password",
        element: lazyRouteElement(() =>
          import("webshop/features/auth/pages/ClientPasswordResetRequestPage")
        ),
      },
      {
        path: "verify-email-request",
        element: lazyRouteElement(() =>
          import(
            "webshop/features/auth/pages/ClientEmailVerificationRequestPage"
          )
        ),
      },
    ],
  },
  {
    path: "arcdroid",
    element: lazyRouteElement(() =>
      import("webshop/pages/arcdroid/ArcDroidLandingPage")
    ),
  },
  {
    path: ":marketingSlug",
    element: lazyRouteElement(() =>
      import("webshop/pages/marketing/MarketingRedirect")
    ),
  },
];

const websiteProtectedRoutes = [
  {
    path: "my",
    element: lazyRouteElement(() =>
      import("webshop/features/my/pages/MyLayout")
    ),
    children: [
      {
        path: "account",
        element: lazyRouteElement(() =>
          import("webshop/features/my/pages/MyAccount")
        ),
      },
      {
        path: "profile",
        element: lazyRouteElement(() =>
          import("webshop/features/my/pages/MyProfile")
        ),
      },
      {
        path: "company",
        element: lazyRouteElement(() =>
          import("webshop/features/my/pages/MyCompany")
        ),
      },
      {
        path: "addresses",
        element: lazyRouteElement(() =>
          import("webshop/features/my/pages/addresses/MyAddresses")
        ),
      },
      {
        path: "lists",
        element: lazyRouteElement(() =>
          import("webshop/features/my/pages/MyLists")
        ),
      },
      {
        path: "team",
        element: lazyRouteElement(() =>
          import("webshop/features/my/pages/team/MyTeam")
        ),
      },
      {
        path: "quotes",
        element: lazyRouteElement(() =>
          import("webshop/features/my/pages/quotes/MyQuotes")
        ),
      },
      {
        path: "orders",
        element: lazyRouteElement(() =>
          import("webshop/features/my/pages/orders/MyOrdersPage")
        ),
      },
      {
        path: "order/:orderNumber",
        element: lazyRouteElement(() =>
          import("webshop/features/my/pages/orders/MyOrderPage")
        ),
      },
      {
        path: "invoices",
        element: lazyRouteElement(() =>
          import("webshop/features/my/pages/invoices/MyInvoices")
        ),
      },
      {
        path: "repairs",
        element: lazyRouteElement(() =>
          import("webshop/features/my/pages/repairs/MyRepairs")
        ),
      },
    ],
  },
];

const websiteNotFoundRoute = {
  path: "*",
  element: lazyRouteElement(() =>
    import("shared/welda/components/error/WebsiteNotFound")
  ),
};

const intranetPublicRoutes = [
  {
    path: "viewDocument",
    element: lazyRouteElement(() => import("intranet/pages/viewDocument")),
  },
  {
    path: "handleoffer",
    element: lazyRouteElement(() => import("intranet/pages/handleOffer")),
  },
  {
    // Public, webshop-independent repair status link (emailed to customers).
    // Lives at host root (e.g. /repair-status?o=&d=&r=&s=) so it works for
    // dossiers that have no operational webshop/site.
    // dossiers that have no operational webshop/site.
    path: "repair-status",
    element: lazyRouteElement(() =>
      import("webshop/pages/repairs/RepairStatusPage")
    ),
  },
  {
    // Employee herstelstaat (DIAS HRSTSTT). Login required.
    // /hrf?o=<dossierNr>&d=<hrbDoknr> — redirects to login with return URL when
    // unauthenticated; clients are sent to the customer herstel summary.
    path: "hrf",
    element: lazyRouteElement(() =>
      import("intranet/pages/public/HerstelstaatPage")
    ),
  },
  {
    // Generic public document PDF. Reuse for other ERP types by allowlisting
    // them in getPublicDocumentUrl and linking /document?e=OFF&o=&d=&r=&s=
    // Invoice (FCT) is not allowlisted — use the authenticated/alternate flow.
    path: "document",
    element: lazyRouteElement(() =>
      import("intranet/pages/public/PublicDocumentPage")
    ),
  },
  {
    // Phone photo upload for a service task, opened from the QR code in the
    // task form. The code is scoped to one task, so no login is needed.
    path: "service-photos/:code",
    element: lazyRouteElement(() =>
      import("intranet/pages/public/ServicePhotoUploadPage")
    ),
  },
  {
    path: "color-management",
    element: lazyRouteElement(() =>
      import("intranet/pages/public/colorManagement")
    ),
  },
  {
    path: "events",
    element: lazyRouteElement(() => import("intranet/layouts/EventLayout")),
    children: [
      {
        path: "subscribe",
        element: lazyRouteElement(() =>
          import("intranet/pages/events/subscribe")
        ),
      },
    ],
  },
  {
    element: lazyRouteElement(() =>
      import("intranet/layouts/EmptyWeldaLayout")
    ),
    children: [
      {
        path: "download_cert",
        element: lazyRouteElement(() =>
          import("intranet/pages/public/download_cert")
        ),
      },
    ],
  },
  {
    path: "internal/stockCountGo",
    element: lazyRouteElement(() =>
      import("intranet/pages/stockCount/stockCountGo")
    ),
  },
  {
    path: "sollicitatie",
    element: lazyRouteElement(() =>
      import("intranet/layouts/SollicitatieLayout")
    ),
    children: [
      {
        path: "",
        element: lazyRouteElement(() =>
          import("intranet/pages/sollicitatie/SollicitatieFormPage")
        ),
      },
      {
        path: ":lang",
        element: lazyRouteElement(() =>
          import("intranet/pages/sollicitatie/SollicitatieFormPage")
        ),
      },
    ],
  },
  {
    element: lazyRouteElement(() =>
      import("shared/falcon/layouts/AuthSimpleLayout")
    ),
    children: [
      {
        path: "login",
        element: lazyRouteElement(() =>
          import("intranet/features/auth/pages/EmployeeLoginPage")
        ),
      },
      {
        path: "logout",
        element: lazyRouteElement(() =>
          import("intranet/features/auth/pages/EmployeeLogoutPage")
        ),
      },
    ],
  },
];

const intranetProtectedRoutes = [
  {
    element: lazyRouteElement(() => import("intranet/layouts/DashboardLayout")),
    children: [
      {
        path: "marketing",
        children: [
          {
            path: "content",
            element: lazyRouteElement(() =>
              import("intranet/features/marketing/pages/contentPage")
            ),
          },
          {
            path: "links",
            element: lazyRouteElement(() =>
              import("intranet/features/marketing/pages/LinksPage")
            ),
          },
          {
            path: "banners",
            element: lazyRouteElement(() =>
              import("intranet/features/marketing/pages/BannersPage")
            ),
          },
          {
            path: "tracking",
            element: lazyRouteElement(() =>
              import("intranet/features/marketing/pages/TrackingPage")
            ),
          },
          {
            path: "carts",
            element: lazyRouteElement(() =>
              import("intranet/features/marketing/pages/CartsPage")
            ),
          },
          {
            path: "orders",
            element: lazyRouteElement(() =>
              import("intranet/features/marketing/pages/OrdersPage")
            ),
          },
          {
            path: "clients",
            element: lazyRouteElement(() =>
              import("intranet/features/marketing/pages/ClientsPage")
            ),
          },
          {
            path: "discounts",
            element: lazyRouteElement(() =>
              import("intranet/features/marketing/pages/DiscountPage")
            ),
          },
          {
            path: "promofolders",
            element: lazyRouteElement(() =>
              import("intranet/features/marketing/pages/PromoFoldersPage")
            ),
          },
          {
            path: "product-groups",
            element: lazyRouteElement(() =>
              import("intranet/features/marketing/pages/ProductGroupsPage")
            ),
          },
          {
            path: "customer-product-queries",
            element: lazyRouteElement(() =>
              import("intranet/features/marketing/pages/CustomerProductQueriesPage")
            ),
          },
          {
            path: "google-merchant",
            element: lazyRouteElement(() =>
              import("intranet/features/marketing/pages/GoogleMerchantPage")
            ),
          },
          {
            path: "product-images",
            element: lazyRouteElement(() =>
              import("intranet/features/marketing/pages/ProductImagesPage")
            ),
          },
        ],
      },
      {
        path: "admin",
        children: [
          {
            path: "users",
            element: lazyRouteElement(() =>
              import("intranet/features/admin/pages/UsersPage")
            ),
          },
          {
            path: "companies",
            element: lazyRouteElement(() =>
              import("intranet/features/admin/pages/CompaniesPage")
            ),
          },
          {
            path: "companies/:id",
            element: lazyRouteElement(() =>
              import("intranet/features/admin/pages/CompanyDetailPage")
            ),
          },

          {
            path: "sessions",
            element: lazyRouteElement(() =>
              import("intranet/features/admin/pages/SessionsPage")
            ),
          },
          {
            path: "guests",
            element: lazyRouteElement(() =>
              import("intranet/features/admin/pages/GuestsPage")
            ),
          },

          {
            path: "routes",
            element: lazyRouteElement(() =>
              import("intranet/features/admin/pages/RoutesPage")
            ),
          },
          {
            path: "issues",
            element: lazyRouteElement(() =>
              import("intranet/features/admin/pages/IssuesPage")
            ),
          },
          {
            path: "ai-prompts",
            element: lazyRouteElement(() =>
              import("intranet/features/admin/pages/AiPromptsPage")
            ),
          },
          {
            path: "sync-runs",
            element: lazyRouteElement(() =>
              import("intranet/features/admin/pages/SyncRunsPage")
            ),
          },
          {
            path: "login-monitor",
            element: lazyRouteElement(() =>
              import("intranet/features/admin/pages/LoginMonitorPage")
            ),
          },
          {
            path: "login-monitor/users/:id",
            element: lazyRouteElement(() =>
              import("intranet/features/admin/pages/LoginMonitorUserPage")
            ),
          },
        ],
      },
      {
        path: "pkdb",
        children: [
          {
            path: "products",
            element: lazyRouteElement(() =>
              import("intranet/features/pkdb/pages/ProductsPage")
            ),
          },
          {
            path: "parameters",
            element: lazyRouteElement(() =>
              import("intranet/features/pkdb/pages/ParametersPage")
            ),
          },
          {
            path: "questions",
            element: lazyRouteElement(() =>
              import("intranet/features/pkdb/pages/QuestionsPage")
            ),
          },
          {
            path: "links",
            element: lazyRouteElement(() =>
              import("intranet/features/pkdb/pages/LinksPage")
            ),
          },
          {
            path: "prompts",
            element: lazyRouteElement(() =>
              import("intranet/features/pkdb/pages/PromptsPage")
            ),
          },
        ],
      },
      {
        path: "",
        element: lazyRouteElement(() => import("intranet/pages/dashboard")),
      },
      {
        path: "offerteopvolging",
        element: lazyRouteElement(() =>
          import("intranet/pages/dashboard/offerteopvolging")
        ),
      },
      {
        path: "offerteopvolging/manager",
        element: lazyRouteElement(() =>
          import("intranet/pages/dashboard/offerteopvolging/manager")
        ),
      },
      {
        path: "regio",
        element: lazyRouteElement(() =>
          import("intranet/pages/dashboard/Regio")
        ),
      },
      {
        path: "auto_off",
        element: lazyRouteElement(() =>
          import("intranet/pages/dashboard/autoopvolging")
        ),
      },
      {
        path: "sales/planning",
        element: lazyRouteElement(() =>
          import("intranet/pages/sales/planning")
        ),
      },
      {
        path: "sales/bezoeken",
        element: lazyRouteElement(() =>
          import("intranet/pages/sales/bezoeken")
        ),
      },
      {
        path: "sales/bezoeken",
        element: lazyRouteElement(() =>
          import("intranet/pages/sales/focus-lists")
        ),
      },
      {
        path: "sales/margin",
        element: lazyRouteElement(() => import("intranet/pages/sales/margin")),
      },
      {
        path: "sales/margin-notes",
        element: lazyRouteElement(() =>
          import("intranet/pages/sales/margin-notes")
        ),
      },
      {
        path: "sales/margin/manager",
        element: lazyRouteElement(() =>
          import("intranet/pages/sales/margin-manager")
        ),
      },
      {
        path: "sales/rode-prijslijst",
        element: lazyRouteElement(() =>
          import("intranet/features/pim/pages/RodePrijslijstPage")
        ),
      },
      {
        path: "sales/focus-lists",
        element: lazyRouteElement(() =>
          import("intranet/pages/sales/focus-lists")
        ),
      },

      {
        path: "sales/verhuur",
        element: lazyRouteElement(() =>
          import("intranet/pages/sales/verhuur/VerhuurDossierPicker")
        ),
      },
      {
        path: "sales/verhuur/:dossier",
        element: lazyRouteElement(() =>
          import("intranet/pages/sales/verhuur/layout")
        ),
        children: [
          {
            path: "",
            element: lazyRouteElement(() =>
              import("intranet/pages/sales/verhuur/VerhuurPage")
            ),
          },
          {
            path: "configuraties",
            element: lazyRouteElement(() =>
              import("intranet/pages/sales/verhuur/VerhuurConfigPage")
            ),
          },
        ],
      },
      {
        path: "sales/e-commerce/shopping-cart/:dossier",
        element: lazyRouteElement(() =>
          import("shared/welda/features/shop/cart/Cart")
        ),
      },
      {
        path: "sales/e-commerce/products/:dossier",
        element: lazyRouteElement(() =>
          import("intranet/pages/sales/e-commerce/layout")
        ),
        children: [
          {
            path: "",
            element: lazyRouteElement(() =>
              import("intranet/pages/sales/e-commerce/products")
            ),
          },
          {
            path: "c/*",
            element: lazyRouteElement(() =>
              import("intranet/pages/sales/e-commerce/products")
            ),
          },
          {
            path: "product/:artikelnr",
            element: lazyRouteElement(() =>
              import(
                "shared/welda/features/shop/products/product-details/ProductDetails"
              )
            ),
          },
        ],
      },
      {
        path: "manageEvents",
        children: [
          {
            path: "",
            element: lazyRouteElement(() => import("intranet/pages/events")),
          },
          {
            path: "scannen",
            element: lazyRouteElement(() =>
              import("intranet/pages/events/scannen")
            ),
          },
          {
            path: "addsubscription",
            element: lazyRouteElement(() =>
              import("intranet/pages/events/addsubscription")
            ),
          },
          {
            path: "aanwezigheid",
            element: lazyRouteElement(() =>
              import("intranet/pages/events/aanwezigheid")
            ),
          },
          {
            path: "analytics",
            element: lazyRouteElement(() =>
              import("intranet/pages/events/analytics")
            ),
          },
          {
            path: "nieuw",
            element: lazyRouteElement(() =>
              import("intranet/pages/events/beheren")
            ),
          },
          {
            path: ":id/bewerken",
            element: lazyRouteElement(() =>
              import("intranet/pages/events/beheren")
            ),
          },
          {
            path: ":id",
            element: lazyRouteElement(() =>
              import("intranet/pages/events/event")
            ),
          },
        ],
      },
      {
        path: "internal/pricetags",
        element: lazyRouteElement(() => import("intranet/pages/pricetags")),
      },
      {
        path: "internal/stockCount",
        element: lazyRouteElement(() => import("intranet/pages/stockCount")),
      },
      {
        path: "internal/StockCountAnalyze",
        element: lazyRouteElement(() =>
          import("intranet/pages/stockCount/stockCountAnalyze")
        ),
      },
      {
        path: "internal/AWTechUpdateFCThistoriek",
        element: lazyRouteElement(() =>
          import("intranet/pages/DiasBytes/AWTechUpdateFCThistoriek")
        ),
      },
      {
        path: "AWTech/DBMapping",
        element: lazyRouteElement(() =>
          import("intranet/pages/awtech/dbmapping")
        ),
      },
      {
        path: "notification/templates",
        element: lazyRouteElement(() =>
          import("intranet/pages/notification/templates")
        ),
      },
      {
        path: "notification/labels",
        element: lazyRouteElement(() =>
          import("intranet/pages/notification/labels")
        ),
      },
      {
        path: "notification/scan",
        element: lazyRouteElement(() =>
          import("intranet/pages/notification/scan")
        ),
      },
      {
        path: "labels/templates",
        element: lazyRouteElement(() =>
          import("intranet/pages/labels/templates")
        ),
      },
      {
        path: "labels/print",
        element: lazyRouteElement(() => import("intranet/pages/labels/print")),
      },
      {
        path: "link/add",
        element: lazyRouteElement(() => import("intranet/pages/link/addLink")),
      },
      {
        path: "link/edit",
        element: lazyRouteElement(() =>
          import("intranet/pages/link/editLinks")
        ),
      },
      {
        path: "link/supplier-docs/import",
        element: lazyRouteElement(() =>
          import("intranet/pages/link/supplier-docs/SupplierDocImport")
        ),
      },
      {
        path: "link/productgroepen",
        element: lazyRouteElement(() =>
          import("intranet/pages/link/Productgroepen")
        ),
      },
      {
        path: "pim/prijsanalyse",
        element: lazyRouteElement(() =>
          import("intranet/features/pim/pages/PriceAnalysisPage")
        ),
      },
      {
        path: "service/mof",
        element: lazyRouteElement(() =>
          import("intranet/pages/service/planning/ServiceMOFPlanningPage")
        ),
      },
      {
        path: "service/todos",
        element: lazyRouteElement(() =>
          import("intranet/pages/service/planning/ServiceTodosPlanningPage")
        ),
      },
      {
        path: "service/calendar",
        element: lazyRouteElement(() =>
          import("intranet/pages/service/planning/ServiceCalendarPage")
        ),
      },
      {
        path: "service/hrb",
        element: lazyRouteElement(() =>
          import("intranet/pages/service/planning/ServiceHRFPlanningPage")
        ),
      },
      {
        path: "service/bestek-preview",
        element: lazyRouteElement(() =>
          import("intranet/pages/service/planning/BestekPreviewPage")
        ),
      },
      {
        path: "service/bestekken",
        element: lazyRouteElement(() =>
          import("intranet/pages/service/planning/BestekTrackingPage")
        ),
      },
      {
        path: "service/analyse/uren",
        element: lazyRouteElement(() =>
          import("intranet/pages/service/analyse/TechnicianHoursPage")
        ),
      },
      {
        path: "service/datadrops",
        element: lazyRouteElement(() =>
          import("intranet/pages/service/DataDrops")
        ),
      },

      {
        path: "warehouse/dispatching",
        element: lazyRouteElement(() =>
          import("intranet/pages/warehouse/dispatching")
        ),
      },
      {
        path: "warehouse/eigen-diensten",
        element: lazyRouteElement(() =>
          import(
            "intranet/pages/warehouse/eigenDiensten/EigenDienstenPlanningPage"
          )
        ),
      },
      {
        path: "warehouse/pickup",
        element: lazyRouteElement(() =>
          import("intranet/pages/warehouse/pickup")
        ),
      },
      {
        path: "finance/lopendeLVB",
        element: lazyRouteElement(() =>
          import("intranet/pages/finance/lopendeLVB")
        ),
      },
      {
        path: "finance/openstaandedoc",
        element: lazyRouteElement(() =>
          import("intranet/pages/finance/OpenstaandeDocComp")
        ),
      },
      {
        path: "finance/openstaandedocsuppliers",
        element: lazyRouteElement(() =>
          import("intranet/pages/finance/cashflow/OpenDocsSuppliersPage")
        ),
      },
      {
        path: "finance/cashflow",
        element: lazyRouteElement(() =>
          import("intranet/pages/finance/cashflow/CashFlowPage")
        ),
      },
      {
        path: "finance/artikel-rekeningen",
        element: lazyRouteElement(() =>
          import("intranet/pages/finance/artikelRekeningen")
        ),
      },
      {
        path: "warehouse/asamco",
        element: lazyRouteElement(() =>
          import("intranet/pages/warehouse/asamco")
        ),
      },
      {
        path: "warehouse/ecom",
        element: lazyRouteElement(() =>
          import("intranet/pages/warehouse/ecom")
        ),
      },
      {
        path: "warehouse/trackers",
        element: lazyRouteElement(() =>
          import("intranet/pages/warehouse/Trackers")
        ),
      },
      {
        path: "warehouse/kardex",
        element: lazyRouteElement(() =>
          import("intranet/pages/warehouse/Kardex")
        ),
      },
      {
        path: "warehouse/hart-actions",
        element: lazyRouteElement(() =>
          import("intranet/pages/warehouse/hartActions")
        ),
      },
      {
        path: "warehouse/stock",
        element: lazyRouteElement(() =>
          import("intranet/pages/sales/artArtmagBase")
        ),
      },
      {
        path: "warehouse/stock-ignored",
        element: lazyRouteElement(() =>
          import("intranet/pages/sales/artArtmagBaseIgnored")
        ),
      },
      {
        path: "warehouse/stock-history",
        element: lazyRouteElement(() =>
          import("intranet/pages/sales/artArtmagBaseHistory")
        ),
      },
      {
        path: "administration/sales",
        element: lazyRouteElement(() =>
          import("intranet/pages/administration/sales")
        ),
      },
      {
        path: "administration/lopendeLVB",
        element: lazyRouteElement(() =>
          import("intranet/pages/finance/lopendeLVB")
        ),
      },
      {
        path: "purchase/todo",
        element: lazyRouteElement(() => import("intranet/pages/purchase/todo")),
      },
      {
        path: "management/datadrops",
        element: lazyRouteElement(() =>
          import("intranet/pages/management/DataDrops")
        ),
      },
      {
        path: "management/openai/sales",
        element: lazyRouteElement(() =>
          import("intranet/pages/management/openai/sales")
        ),
      },
      {
        path: "management/kostenanalyseAWTech",
        element: lazyRouteElement(() =>
          import("intranet/pages/management/kostenanalyseawtech")
        ),
      },
      {
        path: "org/presence",
        element: lazyRouteElement(() =>
          import("intranet/pages/organization/presence")
        ),
      },
      {
        path: "hr/color-management",
        children: [
          {
            path: "",
            element: lazyRouteElement(() =>
              import("intranet/pages/colorManagement")
            ),
          },
          {
            path: ":id",
            element: lazyRouteElement(() =>
              import("intranet/pages/colorManagement/detail")
            ),
          },
        ],
      },
      {
        path: "hr/sollicitaties",
        children: [
          {
            path: "",
            element: lazyRouteElement(() =>
              import("intranet/pages/sollicitatie/HrSollicitatieDashboard")
            ),
          },
          {
            path: ":id",
            element: lazyRouteElement(() =>
              import("intranet/pages/sollicitatie/HrSollicitatieDetail")
            ),
          },
        ],
      },
      {
        path: "hr/badge-momenten",
        element: lazyRouteElement(() =>
          import("intranet/pages/hr/BadgeMomentenPage")
        ),
      },
      {
        path: "hr/aanwezigheid",
        element: lazyRouteElement(() =>
          import("intranet/pages/hr/AanwezigheidPage")
        ),
      },
      {
        path: "eenvoud/interviews",
        children: [
          {
            path: "",
            element: lazyRouteElement(() =>
              import("intranet/features/eenvoud/pages/InterviewsPage")
            ),
          },
          {
            path: ":slug",
            element: lazyRouteElement(() =>
              import("intranet/features/eenvoud/pages/InterviewDetailPage")
            ),
          },
        ],
      },
      {
        path: "eenvoud/processes",
        children: [
          {
            path: "",
            element: lazyRouteElement(() =>
              import("intranet/features/eenvoud/pages/ProcessesPage")
            ),
          },
          {
            path: ":processId",
            element: lazyRouteElement(() =>
              import("intranet/features/eenvoud/pages/ProcessDetailPage")
            ),
          },
        ],
      },
      {
        path: "eenvoud/people",
        element: lazyRouteElement(() =>
          import("intranet/features/eenvoud/pages/PeoplePage")
        ),
      },
      {
        path: "eenvoud/evaluation",
        element: lazyRouteElement(() =>
          import("intranet/features/eenvoud/pages/EvaluationPage")
        ),
      },
      // {
      //   path: "hr/organogram",
      //   element: lazyRouteElement(() =>
      //     import("intranet/pages/hr/OrganogramPage")
      //   ),
      // },
      // react-zoom-pan-pinch is een klote ding met veel warnings
    ],
  },
];

const intranetNotFoundRoute = {
  element: lazyRouteElement(() => import("intranet/layouts/EmptyWeldaLayout")),
  children: [
    {
      path: "*",
      element: lazyRouteElement(() =>
        import("shared/welda/components/error/IntranetNotFound")
      ),
    },
  ],
};

export {
  intranetNotFoundRoute,
  intranetProtectedRoutes,
  intranetPublicRoutes,
  websiteNotFoundRoute,
  websiteProtectedRoutes,
  websitePublicRoutes
};

